// game objects
import { SkySymbol } from "@aceroll/core";
import { Multiplier } from './symbols/multiplier';
import { StickyEye } from './symbols/sticky-eye';
import { Bonus } from './symbols/bonus';

export const symbolsMap = new Map([
    [0, {
        symbol: SkySymbol,
        config: {
            type: 'wild',
            valuable: 0,
            overMask: true,
            default: {
                static: {
                    spritesheet: 'symbols',
                    texture: 'symbols-wild'
                },
                spin: {
                    spritesheet: 'symbols',
                    texture: 'symbols-wild_blur'
                },
                spine: {
                    src: 'spine-symbol_wild',
                    animations: {
                        win: 'win',
                        land: 'land'
                    },
                    skin: 'default'
                },
                frame: {
                    position: 'under',
                    src: 'spine-symbol_frame',
                    animations: {
                        win: 'win_1s',
                        out: 'out_0.2s'
                    },
                    skin: 'default'
                },
                sounds: {
                    win: 'wild'
                }
            }
        }
    }],
    [1, {
        symbol: SkySymbol,
        config: {
            type: 'low',
            valuable: 1,
            default: {
                static: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_1'
                },
                spin: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_1_blur'
                },
                active: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_1_active'
                },
                spine: {
                    src: 'spine-symbol_low',
                    animations: {
                        win: 'win'
                    },
                    skin: '10'
                },
                frame: {
                    position: 'over',
                    src: 'spine-symbol_frame',
                    animations: {
                        win: 'win_1s',
                        out: 'out_0.2s'
                    },
                    skin: 'default'
                },
                sounds: {
                    win: 'low',
                    cheap: 'low_cheap'
                }
            }
        }
    }],
    [2, {
        symbol: SkySymbol,
        config: {
            type: 'low',
            valuable: 2,
            default: {
                static: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_2'
                },
                spin: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_2_blur'
                },
                active: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_2_active'
                },
                spine: {
                    src: 'spine-symbol_low',
                    animations: {
                        win: 'win'
                    },
                    skin: 'J'
                },
                frame: {
                    position: 'over',
                    src: 'spine-symbol_frame',
                    animations: {
                        win: 'win_1s',
                        out: 'out_0.2s'
                    },
                    skin: 'default'
                },
                sounds: {
                    win: 'low',
                    cheap: 'low_cheap'
                }
            }
        }
    }],
    [3, {
        symbol: SkySymbol,
        valuable: 3,
        config: {
            type: 'low',
            valuable: 3,
            default: {
                static: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_3'
                },
                spin: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_3_blur'
                },
                active: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_3_active'
                },
                spine: {
                    src: 'spine-symbol_low',
                    animations: {
                        win: 'win'
                    },
                    skin: 'Q'
                },
                frame: {
                    position: 'over',
                    src: 'spine-symbol_frame',
                    animations: {
                        win: 'win_1s',
                        out: 'out_0.2s'
                    },
                    skin: 'default'
                },
                sounds: {
                    win: 'low',
                    cheap: 'low_cheap'
                }
            }
        }
    }],
    [4, {
        symbol: SkySymbol,
        config: {
            type: 'low',
            valuable: 4,
            default: {
                static: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_4'
                },
                spin: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_4_blur'
                },
                active: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_4_active'
                },
                spine: {
                    src: 'spine-symbol_low',
                    animations: {
                        win: 'win'
                    },
                    skin: 'K'
                },
                frame: {
                    position: 'over',
                    src: 'spine-symbol_frame',
                    animations: {
                        win: 'win_1s',
                        out: 'out_0.2s'
                    },
                    skin: 'default'
                },
                sounds: {
                    win: 'low',
                    cheap: 'low_cheap'
                }
            }
        }
    }],
    [5, {
        symbol: SkySymbol,
        config: {
            type: 'low',
            valuable: 5,
            default: {
                static: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_5'
                },
                spin: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_5_blur'
                },
                active: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_5_active'
                },
                spine: {
                    src: 'spine-symbol_low',
                    animations: {
                        win: 'win'
                    },
                    skin: 'A'
                },
                frame: {
                    position: 'over',
                    src: 'spine-symbol_frame',
                    animations: {
                        win: 'win_1s',
                        out: 'out_0.2s'
                    },
                    skin: 'default'
                },
                sounds: {
                    win: 'low',
                    cheap: 'low_cheap'
                }
            }
        }
    }],
    [6, {
        symbol: SkySymbol,
        config: {
            type: 'high',
            valuable: 6,
            default: {
                static: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_6'
                },
                spin: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_6_blur'
                },
                spine: {
                    src: 'spine-symbol_h1',
                    animations: {
                        win: 'win'
                    },
                    skin: 'default'
                },
                frame: {
                    position: 'over',
                    src: 'spine-symbol_frame',
                    animations: {
                        win: 'win_1s',
                        out: 'out_0.2s'
                    },
                    skin: 'default'
                },
                sounds: {
                    win: 'high_1',
                    cheap: 'high_1_cheap'
                }
            }
        }
    }],
    [7, {
        symbol: SkySymbol,
        config: {
            type: 'high',
            valuable: 7,
            default: {
                static: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_7'
                },
                spin: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_7_blur'
                },
                spine: {
                    src: 'spine-symbol_h2',
                    animations: {
                        win: 'win'
                    },
                    skin: 'default'
                },
                frame: {
                    position: 'over',
                    src: 'spine-symbol_frame',
                    animations: {
                        win: 'win_1s',
                        out: 'out_0.2s'
                    },
                    skin: 'default'
                },
                sounds: {
                    win: 'high_2',
                    cheap: 'high_2_cheap'
                }
            }
        }
    }],
    [8, {
        symbol: SkySymbol,
        config: {
            type: 'high',
            valuable: 8,
            default: {
                static: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_8'
                },
                spin: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_8_blur'
                },
                spine: {
                    src: 'spine-symbol_h3',
                    animations: {
                        win: 'win'
                    },
                    skin: 'default'
                },
                frame: {
                    position: 'over',
                    src: 'spine-symbol_frame',
                    animations: {
                        win: 'win_1s',
                        out: 'out_0.2s'
                    },
                    skin: 'default'
                },
                sounds: {
                    win: 'high_3',
                    cheap: 'high_3_cheap'
                }
            }
        }
    }],
    [9, {
        symbol: SkySymbol,
        config: {
            type: 'high',
            valuable: 9,
            default: {
                static: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_9'
                },
                spin: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_9_blur'
                },
                spine: {
                    src: 'spine-symbol_h4',
                    animations: {
                        win: 'win'
                    },
                    skin: 'default'
                },
                frame: {
                    position: 'over',
                    src: 'spine-symbol_frame',
                    animations: {
                        win: 'win_1s',
                        out: 'out_0.2s'
                    },
                    skin: 'default'
                },
                sounds: {
                    win: 'high_4'
                }
            }
        }
    }],
    [10, {
        symbol: SkySymbol,
        config: {
            type: 'high',
            valuable: 10,
            default: {
                static: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_10'
                },
                spin: {
                    spritesheet: 'symbols',
                    texture: 'symbols-sym_10_blur'
                },
                spine: {
                    src: 'spine-symbol_h5',
                    animations: {
                        win: 'win'
                    },
                    skin: 'default'
                },
                frame: {
                    position: 'over',
                    src: 'spine-symbol_frame',
                    animations: {
                        win: 'win_1s',
                        out: 'out_0.2s'
                    },
                    skin: 'default'
                },
                sounds: {
                    win: 'high_5'
                }
            }
        }
    }],
    [12, {
        symbol: Bonus,
        config: {
            type: 'scatter',
            valuable: 0,
            overMask: true,
            default: {
                static: {
                    spritesheet: 'symbols',
                    texture: 'symbols-bonus'
                },
                spin: {
                    spritesheet: 'symbols',
                    texture: 'symbols-bonus_blur'
                },
                spine: {
                    src: 'spine-symbol_bn',
                    animations: {
                        win: 'win',
                        land: 'idle'
                    },
                    skin: 'default'
                },
                sounds: {
                    win: 'bonus_landed_3',
                    land_1: 'bonus_landed_1',
                    land_2: 'bonus_landed_2'
                }
            },
        },
    }],
    [13, {
        symbol: StickyEye,
        config: {
            type: 'sticky',
            valuable: 0,
            default: {
                static: {
                    spritesheet: 'symbols',
                    texture: 'symbols-eye'
                },
                spin: {
                    spritesheet: 'symbols',
                    texture: 'symbols-eye_blur'
                },
                spine: {
                    src: 'spine-symbol_eye',
                    animations: {
                        idle: 'idle',
                        open: 'open',
                        transition: 'transition_between_numbers'
                    },
                    skin: 'default'
                },
                sounds: {
                    open: 'echospin_appeared',
                    transition: 'echospin_retriggered'
                }
            },
        },
    }],
    [15, {
        symbol: StickyEye,
        config: {
            type: 'sticky',
            valuable: 0,
            default: {
                static: {
                    spritesheet: 'symbols',
                    texture: 'symbols-eye'
                },
                spin: {
                    spritesheet: 'symbols',
                    texture: 'symbols-eye_blur'
                },
                spine: {
                    src: 'spine-symbol_eye',
                    animations: {
                        idle: 'idle',
                        open: 'open',
                        transition: 'transition_between_numbers'
                    },
                    skin: 'default'
                },
                sounds: {
                    open: 'echospin_appeared',
                    transition: 'echospin_retriggered'
                }
            }
        },
    }],
    [21, {
        symbol: Multiplier,
        config: {
            type: 'add',
            valuable: 0,
            default: {
                static: {
                    spritesheet: 'symbols',
                    texture: 'symbols-2x'
                },
                spin: {
                    spritesheet: 'symbols',
                    texture: 'symbols-2x_blur'
                },
                spine: {
                    src: 'spine-symbol_add',
                    animations: {
                        win: 'add'
                    },
                    skin: '2x'
                },
                sounds: {
                    multiply: 'multiplier_symbol_blink'
                }
            }
        }
    }],
    [22, {
        symbol: Multiplier,
        config: {
            type: 'add',
            valuable: 0,
            default: {
                static: {
                    spritesheet: 'symbols',
                    texture: 'symbols-3x'
                },
                spin: {
                    spritesheet: 'symbols',
                    texture: 'symbols-3x_blur'
                },
                spine: {
                    src: 'spine-symbol_add',
                    animations: {
                        win: 'add'
                    },
                    skin: '3x'
                },
                sounds: {
                    multiply: 'multiplier_symbol_blink'
                }
            }
        }
    }],
    [23, {
        symbol: Multiplier,
        config: {
            type: 'add',
            valuable: 0,
            default: {
                static: {
                    spritesheet: 'symbols',
                    texture: 'symbols-4x'
                },
                spin: {
                    spritesheet: 'symbols',
                    texture: 'symbols-4x_blur'
                },
                spine: {
                    src: 'spine-symbol_add',
                    animations: {
                        win: 'add'
                    },
                    skin: '4x'
                },
                sounds: {
                    multiply: 'multiplier_symbol_blink'
                }
            }
        }
    }],
    [24, {
        symbol: Multiplier,
        config: {
            type: 'add',
            valuable: 0,
            default: {
                static: {
                    spritesheet: 'symbols',
                    texture: 'symbols-5x'
                },
                spin: {
                    spritesheet: 'symbols',
                    texture: 'symbols-5x_blur'
                },
                spine: {
                    src: 'spine-symbol_add',
                    animations: {
                        win: 'add'
                    },
                    skin: '5x'
                },
                sounds: {
                    multiply: 'multiplier_symbol_blink'
                }
            }
        }
    }],
    [25, {
        symbol: Multiplier,
        config: {
            type: 'multiplier',
            valuable: 0,
            default: {
                static: {
                    spritesheet: 'symbols',
                    texture: 'symbols-10x'
                },
                spin: {
                    spritesheet: 'symbols',
                    texture: 'symbols-10x_blur'
                },
                spine: {
                    src: 'spine-symbol_add',
                    animations: {
                        win: 'add'
                    },
                    skin: '10x'
                },
                sounds: {
                    multiply: 'multiplier_symbol_blink'
                }
            }
        }
    }],
    [29, {
        symbol: Multiplier,
        config: {
            type: 'multiplier',
            valuable: 0,
            default: {
                static: {
                    spritesheet: 'symbols',
                    texture: 'symbols-x2'
                },
                spin: {
                    spritesheet: 'symbols',
                    texture: 'symbols-x2_blur'
                },
                spine: {
                    src: 'spine-symbol_multiplier',
                    animations: {
                        win: 'multiply'
                    },
                    skin: 'x2'
                },
                sounds: {
                    multiply: 'multiplier_symbol_blink'
                }
            }
        }
    }],
    [30, {
        symbol: Multiplier,
        config: {
            type: 'multiplier',
            valuable: 0,
            default: {
                static: {
                    spritesheet: 'symbols',
                    texture: 'symbols-x3'
                },
                spin: {
                    spritesheet: 'symbols',
                    texture: 'symbols-x3_blur'
                },
                spine: {
                    src: 'spine-symbol_multiplier',
                    animations: {
                        win: 'multiply'
                    },
                    skin: 'x3'
                },
                sounds: {
                    multiply: 'multiplier_symbol_blink'
                }
            }
        }
    }],
]);

window.updateSymbolSound = (symbolId, sound, delay) => {
    const symbol = symbolsMap.get(symbolId);

    if (typeof symbol.config.default.sounds[sound] === 'object') {
        symbol.config.default.sounds[sound].delay = delay;

        console.log(`sound for symbol ${symbolId} updated with delay: ${delay}`);

        return;
    }

    if (typeof symbol.config.default.sounds[sound] === 'string') {
        const curr = symbol.config.default.sounds[sound];

        symbol.config.default.sounds[sound] = {
            sound: curr,
            delay: delay
        };

        console.log(`sound for symbol ${symbolId} updated with delay: ${delay}`);

        return;
    }
}